module.exports = __webpack_public_path__ + "static/media/entry.5c223bba.svg";